import Vue from 'vue'
import Barcode from 'vue-barcode'

Vue.component('Barcode', Barcode)
